import Burger from './Burger';

document.addEventListener('DOMContentLoaded', () => {
  const $burgerElements = document.querySelectorAll('.js-burger');
  if (!$burgerElements.length) {
    return;
  }
  $burgerElements.forEach(($burger) => {
    const burger = new Burger($burger);
    burger.mount();
  });
});
